import EquipmentTypeDoughnutChartAtom from "views/atoms/charts/doughnuts/EquipmentTypeDoughnutChartAtom"
import NodeDoughnutChartAtom from "views/atoms/charts/doughnuts/NodeDoughnutChartAtom"
import React from "react"
import PropTypes from "prop-types"

const EquipmentDetailOrganism = ({ fileQuality, unitType }) => {
  // todo: need improve but now we use distribution_of_valid_entities for purchases, equipment_types for others
  const equipmentData =
    fileQuality?.inventory_type === "purchased_it_services"
      ? fileQuality?.distribution_of_valid_entities
      : fileQuality?.equipment_types

  if (!fileQuality?.nodes)
    return (
      <EquipmentTypeDoughnutChartAtom
        equipmentTypes={equipmentData}
        inventoryType={fileQuality?.inventory_type}
        unitType={unitType}
      />
    )

  return (
    <div className="doughnut-holder">
      <div className="doughnut">
        <EquipmentTypeDoughnutChartAtom
          equipmentTypes={equipmentData}
          inventoryType={fileQuality?.inventory_type}
          unitType={unitType}
        />
      </div>
      <div className="doughnut">
        <NodeDoughnutChartAtom nodes={fileQuality?.nodes} unitType={unitType} />
      </div>
    </div>
  )
}

EquipmentDetailOrganism.propTypes = {
  fileQuality: PropTypes.shape({
    equipment_types: PropTypes.object,
    distribution_of_valid_entities: PropTypes.object,
    nodes: PropTypes.object,
    inventory_type: PropTypes.string,
  }),
  unitType: PropTypes.string,
}

export default EquipmentDetailOrganism
